/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminImageRotateDirection,
    AdminImageRotateDirectionFromJSON,
    AdminImageRotateDirectionFromJSONTyped,
    AdminImageRotateDirectionToJSON,
} from './AdminImageRotateDirection';

/**
 * 
 * @export
 * @interface AdminRotateImageReq
 */
export interface AdminRotateImageReq {
    /**
     * 
     * @type {AdminImageRotateDirection}
     * @memberof AdminRotateImageReq
     */
    direction: AdminImageRotateDirection;
}



export function AdminRotateImageReqFromJSON(json: any): AdminRotateImageReq {
    return AdminRotateImageReqFromJSONTyped(json, false);
}

export function AdminRotateImageReqFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminRotateImageReq {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'direction': AdminImageRotateDirectionFromJSON(json['direction']),
    };
}

export function AdminRotateImageReqToJSON(value?: AdminRotateImageReq | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'direction': AdminImageRotateDirectionToJSON(value.direction),
    };
}

